import React from "react";
import { useLocation } from "react-router-dom";
import SignatureManager from "./SignatureManager";
import ReviewManager from "./ReviewManager";

const ConsentHistoryBody = ({
  username,
  employerName,
  signedDate,
  isSigned,
  whId,
  effectiveUserId,
  isAdmin,
  onSignComplete,
  title = "Consent to Safety and Performance History",
  taskId = 24, // numeric taskId; used with referenceId so status is per employer
}) => {
  const location = useLocation();
  const isSlide = location.pathname.startsWith("/slide/");

  return (
    <>
      {isSlide && (
        <div
          className="d-flex justify-content-between align-items-center px-3 mb-4"
          style={{
            paddingTop: "16px",
            paddingBottom: "8px",
            borderBottom: "1px solid #ccc",
          }}
        >
          <h4
            className="m-0"
            style={{ fontWeight: 500, color: "#333", fontSize: 18 }}
          >
            Review and Sign Consent – {title}
          </h4>
        </div>
      )}

      <p>
        I hereby authorize my previous employers to release and forward all
        information regarding my alcohol and controlled substances testing and
        any violations of Department of Transportation (DOT) regulations within
        the previous three years from the date below. This information will be
        used for the purpose of investigating my safety performance history as
        required by 49 CFR 391.23 of the Federal Motor Carrier Safety
        Regulations.
      </p>
      <p>
        I understand that the information released will be used to determine my
        eligibility for employment as a driver. I release my previous employers
        from any liability for providing such information.
      </p>

      {employerName && (
        <div className="alert alert-light border mt-5">
          This document applies to the following previous employer:{" "}
          <strong>{employerName}</strong>
        </div>
      )}

      <form>
        <div className="row mb-3 mt-5">
          <div className="col">
            <label className="form-label">Employee Name</label>
            <input
              type="text"
              className="form-control"
              value={username}
              readOnly
            />
          </div>
          <div className="col">
            <label className="form-label">Date</label>
            <input
              type="text"
              className="form-control"
              value={
                isSigned && signedDate
                  ? new Date(signedDate).toLocaleDateString()
                  : new Date().toLocaleDateString()
              }
              readOnly
            />
          </div>
        </div>
      </form>

      {effectiveUserId && (
        <>
          <SignatureManager
            taskName="consent_history"
            taskId={taskId} // 🔑 used with referenceId to key "24_<whId>"
            referenceId={whId} // 🔑 ut_reference_id = this employer's wh_id
            userId={effectiveUserId}
            isAdmin={isAdmin}
            isSigned={isSigned}
            signdate={signedDate}
            onSignComplete={onSignComplete}
          />

          <ReviewManager
            taskName="consent_history"
            taskId={24} // consent history taskId
            referenceId={whId} // employer reference ID
            userId={effectiveUserId}
            isAdmin={isAdmin}
          />
        </>
      )}
    </>
  );
};

export default ConsentHistoryBody;
